import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'
import { initArray } from 'model/helpers'
import TagAttribute from 'model/tag/tagAttribute'

class IntakeTag extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._color = init.color
    this._id = init.id
    this._name = init.name
    this._type = init.type
    this._description = init.description
    this._intake_queues = init?.intake_queues?.nodes
    this._intake_queues_count = init.intake_queues_count
    this._intake_tag_attributes = initArray(
      init,
      ['intake_tag_attributes'],
      TagAttribute
    )
    this._match_operator = init.match_operator
    this._status = init.status
    this._tickets = init?.tickets?.nodes
    this._tickets_count = init.tickets_count
  }

  static shape = {
    color: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
    intake_queues: PropTypes.object,
    tickets: PropTypes.array,
    intake_tag_attributes: PropTypes.arrayOf(
      PropTypes.instanceOf(TagAttribute)
    ),
    status: PropTypes.string,
    tickets_count: PropTypes.int,
    intake_queues_count: PropTypes.int,
    match_operator: PropTypes.string
  }

  get color() {
    return this._color
  }

  get id() {
    return this._id
  }

  get name() {
    return this._name
  }

  get description() {
    return this._description
  }

  get intake_queues() {
    return this._intake_queues || []
  }

  get intake_tag_attributes() {
    return this._intake_tag_attributes || []
  }

  get match_operator() {
    return this._match_operator
  }

  get tickets() {
    return this._tickets || []
  }

  get status() {
    return this._status
  }

  get tickets_count() {
    return this._tickets_count
  }

  get type() {
    return this._type
  }

  get intake_queues_count() {
    return this._intake_queues_count
  }
}

export default IntakeTag
